import { AfterViewInit, Component, input, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GridStackOptions } from 'gridstack';
import { GridstackModule } from 'gridstack/dist/angular';

import { GridstackHeaderItem } from '@models/common';
import { GridstackHeaderPipe } from '@shared/components/data-list/gridstack-header/common';

@Component({
  selector: 'cipo-gridstack-header',
  imports: [GridstackModule, GridstackHeaderPipe, TranslateModule],
  templateUrl: './gridstack-header.component.html',
  styles: [
    `
      .aggregate-item {
        background-color: var(--black-50);
        padding: 4px;
        border-radius: 4px;
        border: 1px solid var(--black-100);

        p {
          font-size: var(--cipo-font-xs);
          font-weight: 600;
          text-transform: uppercase;
        }
      }
    `,
  ],
})
export class GridstackHeaderComponent implements AfterViewInit {
  headerItems = input<GridstackHeaderItem[]>();
  data = input<Record<number, any>>({});

  viewInitialized = signal(false);
  gridOptions: GridStackOptions = {
    cellHeight: 34,
    margin: '0 2px 2px 0',
    disableDrag: true,
    disableResize: true,
  };

  ngAfterViewInit(): void {
    this.viewInitialized.set(true);
  }
}
